// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".excelTempate[data-v-63471f03]{margin-bottom:5px;text-align:center}.upload-demo[data-v-63471f03]{text-align:center;padding-top:1rem;padding-bottom:1rem}", ""]);
// Exports
module.exports = exports;
